import type { UiStrings } from '@/constants/ui-locale'

export default function SharedRoomSimilarChip({
  t,
  onJoin,
}: {
  t: UiStrings
  onJoin: () => void
}) {
  return (
    <div
      data-testid="shared-room-header-similar"
      className="inline-flex max-w-[min(42vw,16rem)] shrink-0 items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-2 py-0.5 text-[11px] font-semibold text-orange-800 dark:border-orange-800/50 dark:bg-orange-950/40 dark:text-orange-200 sm:max-w-none sm:gap-2 sm:px-3 sm:py-1 sm:text-xs"
    >
      <svg
        className="h-3.5 w-3.5 shrink-0 text-orange-500 sm:h-4 sm:w-4"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden
      >
        <path d="M16 11c1.657 0 3-1.567 3-3.5S17.657 4 16 4s-3 1.567-3 3.5 1.343 3.5 3 3.5zM8 11c1.657 0 3-1.567 3-3.5S9.657 4 8 4 5 5.567 5 7.5 7.343 11 8 11zM8 13c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zM16 13c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
      </svg>
      <span className="min-w-0 truncate">{t.similarMeetingDetected}</span>
      <span aria-hidden className="shrink-0 text-orange-400">
        ·
      </span>
      <button
        type="button"
        onClick={onJoin}
        className="shrink-0 underline decoration-orange-600/60 underline-offset-2 hover:text-orange-950 dark:hover:text-orange-100"
      >
        {t.sharedRoomJoinLink}
      </button>
    </div>
  )
}
